import { attachmentApi } from '@/store/services/attachment.service'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLoaderData } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { Pill } from '@/shared/components/pill'
import { store } from '@/store'
import { AttachmentTableWithTabs } from '@/shared/components/attachments'
import { useAuthorization } from '@/hooks'
import { HasAccess } from '@permify/react-role'
import { attachmentUpload, list } from '@/router/utils'

export const CompanyAttachments = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const { company: currentCompany } = useLoaderData()
  const defaultSearchParams = {
    attachable_type: 'Contractor::Company',
    attachable_id: currentCompany.id
  }

  const { t } = useTranslation()
  const pillOptions = useMemo(() => {
    return [
      { label: t('company.name'), value: currentCompany.name },
      { label: t('documentNumber.one'), value: currentCompany.documentNumber }
    ]
  }, [currentCompany])

  const getMore = async (searchParams) => {
    try {
      const {
        attachments = [], meta = {}
      } = await store.dispatch(
        attachmentApi.endpoints.getAttachments.initiate(`?${searchParams.toString()}`)
      ).unwrap()

      const currentPage = Number(searchParams.get('page'))
      const hasMore = currentPage < meta?.pagination?.total_pages

      return {
        attachments,
        hasMore
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    hasAccess('company#attachments')
  }, [])

  return (
    <Dialog size='xl' className='h-4/5' open={true}>
      <DialogHeader>Detalle de documentos subidos</DialogHeader>

      <DialogBody className='overflow-hidden' style={{ height: 'inherit' }}>
        <div className='flex gap-3 mb-5'>
          {!!pillOptions.length &&
            pillOptions.map(({ value, label }) => (
              <Pill key={value} label={label} value={value} />
            ))}
        </div>

        <AttachmentTableWithTabs
          initialSearchParams={defaultSearchParams}
          getMore={getMore}
        />
      </DialogBody>

      <DialogFooter className='flex gap-3'>
        <LinkWithQuery to={list('companies')}>
          <Button
            variant='outlined'
            color='white'
          >
            Volver
          </Button>
        </LinkWithQuery>

        <LinkWithQuery to={attachmentUpload('companies', currentCompany.id)}>
          <Button>
            Añadir documento
          </Button>
        </LinkWithQuery>
      </DialogFooter>
    </Dialog>
  )
}
